"use client";
import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef } from "react";

interface UnderlinedTextProps {
  text: string;
}

export default function UnderlinedText({ text }: UnderlinedTextProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const controls = useAnimation();
  const isInView = useInView(ref, { once: true, margin: "-20% 0px" });

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const variants = {
    hidden: { "--progress": 0 } as any,
    visible: { "--progress": 1 } as any,
  };

  return (
    <motion.span
      ref={ref}
      className="underlined-text"
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {text}
    </motion.span>
  );
}
